// useComments — récupère les commentaires de la cliente + action de validation (Jalon 3.4).

import { useCallback, useEffect, useState } from 'react';
import { api } from '../lib/api';

export interface AiSuggestions {
  action: 'SUGGEST' | 'FLAG' | 'REFUSE';
  suggestions: string[];
  reason: string;
}

export interface CommentItem {
  id: string;
  authorHandle: string;
  text: string;
  postId: string;
  sentiment: 'POSITIVE' | 'NEUTRAL' | 'NEGATIVE' | null;
  sensitivityLevel: 'NONE' | 'MODERATE' | 'STRONG' | 'HATER' | null;
  tofuMofuBofu: 'TOFU' | 'MOFU' | 'BOFU' | null;
  status: string;
  aiSuggestions: AiSuggestions | null;
  createdAt: string;
}

export function useComments(status = 'PENDING'): {
  comments: CommentItem[];
  loading: boolean;
  error: string | null;
  reload: () => Promise<void>;
} {
  const [comments, setComments] = useState<CommentItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await api.get<{ comments: CommentItem[] }>(`/api/comments?status=${status}`);
      setComments(res.comments);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Erreur de chargement');
    } finally {
      setLoading(false);
    }
  }, [status]);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { comments, loading, error, reload };
}

export async function validateReply(
  commentId: string,
  text: string,
): Promise<{ published: boolean }> {
  return api.post<{ ok: boolean; published: boolean }>(`/api/comments/${commentId}/validate`, {
    text,
  });
}

export async function contestComment(commentId: string, message: string): Promise<void> {
  await api.post(`/api/comments/${commentId}/contest`, { message });
}
